import $ from 'jquery'
import Vue from 'vue'
import './raven'

window.$ = window.jQuery = $
window.Vue = Vue

require('babel-runtime/core-js/promise').default = require('bluebird')
window.Promise = require('bluebird')

window.Popper = require('popper.js').default
require('bootstrap/js/dist/util')
require('bootstrap/js/dist/tooltip')
require('bootstrap/js/dist/dropdown')
require('bootstrap/js/dist/collapse')
require('bootstrap/js/dist/modal')
require('bootstrap/js/dist/alert')

$(document).tooltip({
  selector: '[data-toggle="tooltip"]',
  animation: false,
})

const moment = require('moment')
moment.locale('ru')
moment.updateLocale('ru', {
  relativeTime: {
    h: '%d час', // '1 час' вместо 'час'
    d: '%d день',
    M: '%d месяц',
    y: '%d год',
  },
})

require('./inputmask')



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js